module.exports = __webpack_public_path__ + "img/building-03.b3cd8623.svg";